/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sub_Downgrade_Token_Credit_PoolInputs */



/**
* | output |
* | --- |
* | "Token credit pool" |
*
* @param {Sub_Downgrade_Token_Credit_PoolInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_downgrade_token_credit_pool = /** @type {((inputs?: Sub_Downgrade_Token_Credit_PoolInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Downgrade_Token_Credit_PoolInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Token-Guthaben-Pool")
	return /** @type {LocalizedString} */ ("Token credit pool")
});